<template>
	<section v-if="isSlickCarousel" class="banner-slider">
		<SlickCarousel :settings="settings">
			<template v-slot:slideContents>
				<div v-for="item in mainBannerList" :key="item.wp_id">
					<router-link
						:to="{ name: 'promotionDetail', params: { id: item.wp_id } }"
					>
						<img :src="item.upload_url" :alt="item.wb_source" />
					</router-link>
				</div>
			</template>
		</SlickCarousel>
	</section>
</template>

<script>
import SlickCarousel from '@/components/SlickCarousel';

export default {
	components: {
		SlickCarousel,
	},
	data() {
		return {
			isSlickCarousel: false,
			settings: {
				arrows: false,
				dots: false,
				infinite: true,
				autoplay: true,
			},
		};
	},
	computed: {
		mainBannerList() {
			return this.$store.getters['bannerStore/mainBannerList'];
		},
	},
	created() {
		this.fetchMainBannerList();
	},
	methods: {
		async fetchMainBannerList() {
			await this.$store.dispatch('bannerStore/getMainBannerList');
			this.isSlickCarousel = this.mainBannerList.length ? true : false;
		},
	},
};
</script>

<style scoped>
.banner-slider {
	margin-top: 1rem;
	border-radius: 0.125rem;
	text-align: center;
	overflow: hidden;
}

.banner-slider a {
	outline: none;
}

.banner-slider img {
	width: 100%;
}
</style>
